import { defineComponent as _defineComponent } from 'vue'
import type { Genre } from '@/constants/types';
import type { CollectionType } from '@/enums/collection-type';
import type { FilterCollection, FilterName } from '@/stores/filter.store';

import ResetButton from '@/components/buttons/ResetButton.vue';
import ToggleButton from '@/ui-components/ToggleButton.vue';

import { useI18n } from '@/helpers/composables/useI18n';
import { toastSuccess } from '@/helpers/toast/toast-helper';
import { isFilterActive } from '@/helpers/filter-helper';
import { useConstantStore, useFilterStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterBarGenres',
  props: {
    collectionType: null,
    currentFilters: null
  },
  setup(__props: any) {

const props = __props as {
	collectionType: CollectionType;
	currentFilters: FilterCollection;
};



const { genres } = useConstantStore();

function isFilterCurrentlyActive(filterName: FilterName, value: any) {
	return isFilterActive(filterName, value, props.currentFilters);
}

const { t } = useI18n();
const { toggle } = useFilterStore();
function genreClicked(genre: Genre) {
	const genreShortName = genre.shortName;
	const isIncluded = isFilterCurrentlyActive('genres', genreShortName);
	const isExcluded = isFilterCurrentlyActive('exclude_genres', genreShortName);

	if (!isIncluded && !isExcluded) {
		// neutral -> transition to included
		toggle({
			filterName: 'genres',
			value: genreShortName,
			selectedState: 1,
		});
	} else if (isIncluded) {
		// included -> transition to excluded
		toggle({
			filterName: 'genres',
			value: genreShortName,
			selectedState: 0,
			trackEvent: false,
		});
		toggle({
			filterName: 'exclude_genres',
			value: genreShortName,
			selectedState: 1,
		});

		toastSuccess({ message: t('WEBAPP_EXCLUDE_X_GENRE', { genre: genre.translation }).toString() });
	} else if (isExcluded) {
		// excluded -> transition to neutral
		toggle({
			filterName: 'exclude_genres',
			value: genreShortName,
			selectedState: 0,
		});
	}
}

return { __sfc: true,props, genres, isFilterCurrentlyActive, t, toggle, genreClicked, ResetButton, ToggleButton }
}

})